/* We separate out the *build-time* `process.env` processing from the *run-time* processing for a few reasons:
 *
 * 1. Type checking and schema enforcement needs to happen at build time
 * 2. We don't want/need to bundle zod in with the client JS
 */
import { CLIENT_ENV } from '@lib/env';

const isProduction = () => {
  return CLIENT_ENV.NEXT_PUBLIC_NODE_ENV === 'production';
};

// Note: the following will use the production app when running next.js as a
// production build. e.g. `next build && next start`
const getAppOrigin = () => {
  if (isProduction()) {
    return 'https://app.wistia.com';
  }
  return 'https://app.wistia.io';
};

export const APP_ORIGIN = getAppOrigin();

export const IS_PRODUCTION = isProduction();

export const GTM_ID = 'GTM-WJT32MJ';

export const EV1_URL = 'https://fast.wistia.com/assets/external/E-v1.js';

export const CHROMATIC_VIDEO_DELAY = 3000;

export const WISTIA_FREE_ACCOUNT =
  'https://app.wistia.com/auth/wistia_auth_register_pre_auth?plan_type=free';
export const WISTIA_PLUS_TRIAL =
  'https://app.wistia.com/auth/wistia_auth_register_pre_auth?plan_type=plus_trial';
export const WISTIA_PRO_TRIAL =
  'https://app.wistia.com/auth/wistia_auth_register_pre_auth?plan_type=pro_trial';
export const WISTIA_ADVANCED_TRIAL =
  'https://app.wistia.com/auth/wistia_auth_register_pre_auth?plan_type=advanced_trial';
export const HUBSPOT_PORTAL_ID = '120237';

// HubSpot form name: [Storefront Engineering Example] Form with all field types
export const HUBSPOT_TEST_FORM_ID = '66aa2305-16d4-4800-bc82-aa975a379851';

// HubSpot form name: [Sales] Premium Plan - GIT Request (Website)
export const HUBSPOT_GIT_SALES_FORM_ID = 'c59d4834-0b02-4275-aac0-6cc1e7599395';

// HubSpot form name: [Marketing] Library: Music: Let 'em in
export const HUBSPOT_MUSIC_DOWNLOAD_FORM_ID =
  '9fe32f1f-a6d7-48bf-be11-6988b87c1d2c';

// HubSpot form name: [Product] New Free Account
export const HUBSPOT_NEW_FREE_ACCT_FORM_ID =
  '7bcd4439-7436-433d-bbea-6b7b1f9e4271';

// HubSpot form name: [Marketing] Blog content signup - w. Captcha - 11.15.22
// This is an iframe
export const HUBSPOT_BLOG_SIGNUP_FORM_ID =
  '5e469e58-cd1b-48c8-80e1-bc0e3b686ba1';

// HubSpot form name: [Sales] Cross-Device Tracking Example
// This is an iframe
export const HUBSPOT_NEW_EDITOR_FORM_ID =
  '9ea846aa-9617-456e-8038-b5966a1f78d6';

// Note: the following two APIs are read-only JSON return objects. Future
// refinement will be to make these more consistent (one internal API?) and
// more flexible with environments (dev/staging/production).
// Note 2: both are managed at the moment by Legacy (/data/pricing)
export const PRICING_GRID_API =
  'https://wistia.com/api/pricing/features?version=updated';
export const PRICING_FAQ_API = 'https://wistia.com/api/pricing/faqs';

export const MOBILE_NAVBAR_OFFSET_WITH_HOMEPAGE_PROMO = 145;
export const MOBILE_NAVBAR_OFFSET_DEFAULT = 60;
